import { Objects } from "src/modules/utils/shared/objects";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { PrimaryGeneratedColumn } from "typeorm";

export class SmBaseEntity {
    @PrimaryGeneratedColumn()
    id: number = 0;

    getStringRepresentation(): string {
        return this.getEntityName() + ": " + this.id;
    }

    getEntityName(): string {
        return Objects.getTypeName(this);
    }

    toString(): string {
        return this.getStringRepresentation();
    }
}